import { RadioGroup } from 'react-aria-components';
import { useController } from 'react-hook-form';
import RadioOption from '../ui/RadioOption';

type RadioGroupFieldProps = {
  name: string;
  control: any;
  options: { label: string; value: string }[];
  isRequired?: boolean;
  radioLabel: string;
};

const RadioGroupField = ({
  name,
  control,
  options,
  isRequired,
  radioLabel,
}: RadioGroupFieldProps) => {
  const { field } = useController({
    name,
    control,
  });

  return (
    <RadioGroup
      {...field}
      isRequired={isRequired}
      aria-label={radioLabel}
      value={field.value}
      onChange={(val) => field.onChange(val)}
      className="grid w-full grid-cols-3 gap-3 compact:flex compact:flex-wrap compact:gap-2"
    >
      {options.map((option) => (
        <RadioOption key={option.value} value={option.value} label={option.label} />
      ))}
    </RadioGroup>
  );
};

export default RadioGroupField;
